import React, { Component } from 'react'

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';



export class CollectionLevels extends Component {

    state = {
        // collection: 'word_set',
        // collections:[{name:"word_set"},{name:"word_temp"}],
        level:1,
        levels:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
      }

      handleCollectionLevelChange=(event)=> {
        this.setState({ 
            level: event.target.value
     });
      this.props.handleCollectionLevelChange(event.target.value);
   }

   componentDidMount() {

    }

    render() {
        return (
            <FormControl fullWidth >
                            <InputLabel htmlFor="name-Level">Level</InputLabel>
                                <Select 
                                fullWidth
                                value={this.state.level}
                                onChange={this.handleCollectionLevelChange}
                                inputProps={{
                                    name: 'Collection',
                                    id: 'name-Collection',
                                }}
                                >

                                                                    {

                                    (typeof this.state.levels != 'undefined')  && this.state.levels.map(se => (
  
                                    <MenuItem value={se}>{se}</MenuItem>
                                    )
                                    )}
                                </Select>
                        </FormControl>
        )
    }
}

export default CollectionLevels
